module.exports = __webpack_public_path__ + "img/vip.304e6ae3.jpg";